/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Live_NowInputs */

const en_go_live_now = /** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Live Now`)
};

const id_go_live_now = /** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tayangkan Sekarang`)
};

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const es_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const fr_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const de_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const ja_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const zh_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const ar_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const it_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const ru_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const pt_go_live_now = en_go_live_now;

/** @type {(inputs: Go_Live_NowInputs) => LocalizedString} */
const ko_go_live_now = en_go_live_now;

/**
* | output |
* | --- |
* | "Go Live Now" |
*
* @param {Go_Live_NowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_live_now = /** @type {((inputs?: Go_Live_NowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Live_NowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_live_now(inputs)
	if (locale === "es") return es_go_live_now(inputs)
	if (locale === "fr") return fr_go_live_now(inputs)
	if (locale === "de") return de_go_live_now(inputs)
	if (locale === "ja") return ja_go_live_now(inputs)
	if (locale === "zh") return zh_go_live_now(inputs)
	if (locale === "ar") return ar_go_live_now(inputs)
	if (locale === "id") return id_go_live_now(inputs)
	if (locale === "it") return it_go_live_now(inputs)
	if (locale === "ru") return ru_go_live_now(inputs)
	if (locale === "pt") return pt_go_live_now(inputs)
	return ko_go_live_now(inputs)
});